import { DisplayValuesMap } from '~/common/types/data';
import { PcfraReviewDateFilterValue } from '~/common/types/residentsReport';

export const pcfraReviewDateFilterValueDisplayValues: DisplayValuesMap<PcfraReviewDateFilterValue> =
  {
    overdue: 'Overdue',
    'within-60-days': 'Due within 60 days',
    later: 'Due later',
    'not-set': 'Not set',
  };
